import { getSettings } from './settings';

let ctx: AudioContext | null = null;

function tone(freq: number, ms: number, gain = 0.05): void {
  if (!getSettings().sound) return;
  try {
    ctx ??= new AudioContext();
    const osc = ctx.createOscillator();
    const g = ctx.createGain();
    osc.frequency.value = freq;
    osc.type = 'sine';
    g.gain.value = gain;
    osc.connect(g).connect(ctx.destination);
    const t = ctx.currentTime;
    g.gain.setValueAtTime(gain, t);
    g.gain.exponentialRampToValueAtTime(0.0001, t + ms / 1000);
    osc.start(t);
    osc.stop(t + ms / 1000);
  } catch {
    /* audio unavailable */
  }
}

function vibrate(pattern: number | number[]): void {
  if (!getSettings().haptics) return;
  try {
    navigator.vibrate?.(pattern);
  } catch {
    /* unsupported */
  }
}

export const feedback = {
  tap(): void {
    vibrate(8);
  },
  accepted(): void {
    tone(880, 120);
    vibrate(25);
  },
  rejected(): void {
    tone(220, 160, 0.04);
    vibrate([15, 40, 15]);
  },
  end(): void {
    tone(660, 200);
    vibrate(60);
  },
};
